export default __webpack_public_path__ + "static/media/groupIconDark.e27a6d04.svg";